import axios from 'axios';
import router from '../router';
import { getBaseURL, timeoutAxios } from './entorno';

const instance = axios.create({
  baseURL: getBaseURL(),
  timeout: timeoutAxios(),
  headers: {
    'Content-Type': 'application/json'
  }
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Error en petición Axios:', error);

    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      ['miDia:ticktick:v1', 'miDia:datos:v1', 'miDia:agenda:v1'].forEach((k) => localStorage.removeItem(k));
      if (router.currentRoute.value.path !== '/login') {
        router.push('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
